'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ToolbarContext: function() {
        return ToolbarContext;
    },
    useToolbarContext_unstable: function() {
        return useToolbarContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const ToolbarContext = (0, _reactcontextselector.createContext)(undefined);
const toolbarContextDefaultValue = {
    size: 'medium',
    handleToggleButton: ()=>null,
    handleRadio: ()=>null,
    vertical: false,
    checkedValues: {}
};
const useToolbarContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(ToolbarContext, (ctx = toolbarContextDefaultValue)=>selector(ctx));
